import { DotLoading } from "antd-mobile";

const PageLoading = ({ tip, style }: { tip?: string; style?: React.CSSProperties }) => (
  <div
    style={{
      paddingTop: "40%",
      textAlign: "center",
      position: "fixed",
      background: "#fff",
      height: "100vh",
      width: "100vw",
      top: 0,
      left: 0,
      ...style,
    }}
  >
    <span style={{ fontSize: 18 }}>
      <DotLoading />
    </span>
    <br />
    <span style={{ fontSize: 16 }}>{tip || "加载中..."}</span>
  </div>
);

export default PageLoading;
